<form [formGroup]="confirmForm">
  <div class="flex flex-row container justify-center items-center content-center text-center">
    <div class="basis-2/5 wrapper">
      <div class="justify-center items-center text-center">
        <img src="assets/images/logo-img.svg" alt="BeeFund" class="mx-auto"/>
        <h1 mat-dialog-title>{{ 'Registratie voltooid' | translate }}</h1>
        <p>{{ 'Bedankt voor het bevestigen van jouw registratie.' | translate }}</p>
      </div>
      <div class="flex flex-col justify-center items-center content-center margin-right-10">
        <button mat-raised-button color="accent" routerLink="/">{{'Naar de acties'|translate}}</button>
      </div>
    </div>
  </div>
</form>
